// DS: C92
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '../../../biLogger/constants';
import { IconSize } from '../../../Icons/IconWrap';
import shortenNumber from '../../../utils/shortenNumber';
import { getDeviationStats } from './helpers';
import FavouriteIcon from '../../../Icons/Favourite';
import CommentIcon from '../../../Icons/Comment';
import Eyecon from '../../../Icons/Eye';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import s from './Stats.scss';
var Stats = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var _b = getDeviationStats(deviation), faves = _b.faves, comments = _b.comments, views = _b.views, viewsToday = _b.viewsToday, isFavouritable = _b.isFavouritable, isCommentable = _b.isCommentable, isViewCountable = _b.isViewCountable;
    var shorten = function (number) { return shortenNumber(number, 0, Math.floor); };
    return (React.createElement("div", { className: s['root'] },
        isFavouritable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "favourite", dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, tooltipDataHook: BiDataHook.DEVIATION_FAVERS_LIST },
            React.createElement(FavouriteIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: s['stat-icon'] }),
            ' ',
            shorten(faves))),
        isCommentable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "comment", dataHook: BiDataHook.DEVIATION_COMMENTS_COUNTER },
            React.createElement(CommentIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: classnames(s['stat-icon'], 
                // don't ask, please
                s['pixel-pushing-for-no-good-reason']) }),
            ' ',
            shorten(comments))),
        isViewCountable && (React.createElement("span", { className: s['stat'] },
            React.createElement(Eyecon, { size: IconSize.SMALL, disableDefaultColors: true, className: s['stat-icon'] }),
            ' ',
            shorten(views),
            " (",
            shorten(viewsToday),
            " ",
            t('deviation.details.today'),
            ")"))));
};
export default Stats;
//# sourceMappingURL=Stats.js.map